export const getData = (key) => {
  let data = {};

  try {
    const raw = localStorage.getItem(key);

    if (raw) data = JSON.parse(raw);
  } catch (err) {}
  return data;
};

export const saveData = (key, formEl) => {
  if (typeof window === "undefined") return;
  const { app } = window;
  const data = getData(key);
  const keyPairs = getKeyPairsInForm(formEl || app.getEl("form"));

  for (const entry of keyPairs) {
    data[entry[0]] = entry[1];
  }
  // Convert email params to lower case
  if (data.email && typeof data.email === "string") {
    data.email = data.email.toLowerCase().trim();
  }
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (err) {}
  return data;
};

export const getKeyPairsInForm = (formEl) => {
  const keyPairs = [];

  formEl.querySelectorAll("input, textarea").forEach((inputEl) => {
    keyPairs.push([inputEl.name, inputEl.value]);
  });
  formEl.querySelectorAll("select").forEach((selectEl) => {
    keyPairs.push([
      selectEl.name,
      selectEl.options[selectEl.selectedIndex].value,
    ]);
  });
  return keyPairs;
};

export const validateRequired = (storageKey, fieldNames, formEl) => {
  if (typeof window === "undefined") return;
  const { app } = window;
  let data = getData(storageKey);
  let isValid = true;

  app.getEls(".errored").forEach((el) => {
    el.classList.remove("errored");
    el.removeAttribute("data-error");
  });
  fieldNames.forEach((name) => {
    const selector = `[name="${name}"]`;
    const fieldEl = formEl
      ? formEl.querySelector(selector)
      : app.getEl(selector);

    if (data[name]) return;
    if (!fieldEl) {
      isValid = false;
      return;
    }
    if (fieldEl.value) return;
    const specialEl = app.closest(fieldEl, ".select, .checkbox, .radio");
    const wrapperEl = app.closest(fieldEl, ".field");
    const error = "* Required field";

    if (specialEl) specialEl.classList.add("errored");
    if (wrapperEl) {
      wrapperEl.classList.add("errored");
      wrapperEl.setAttribute("data-error", error);
    }
    fieldEl.classList.add("errored");
    isValid = false;
  });
  return isValid;
};

export const validateEmail = (storageKey, fieldNames, formEl) => {
  if (typeof window === "undefined") return;
  const { app } = window;
  let data = getData(storageKey);
  let isValid = true;

  fieldNames.forEach((name) => {
    const selector = `[name="${name}"]`;
    const fieldEl = formEl
      ? formEl.querySelector(selector)
      : app.getEl(selector);
    const value = fieldEl && fieldEl.value ? fieldEl.value : data[name];

    if (
      value.match(
        /[a-z0-9\^\.\|\?\*\+\-\{\}\$!#%&'`~=_]+@[a-z0-9\-]+\.[a-z]{2,}/i
      )
    )
      return;
    if (!fieldEl) {
      isValid = false;
      return;
    }
    const wrapperEl = app.closest(fieldEl, ".field");
    const error = "* Invalid email address";

    if (wrapperEl) {
      wrapperEl.classList.add("errored");
      wrapperEl.setAttribute("data-error", error);
    }
    fieldEl.classList.add("errored");
    isValid = false;
  });
  return isValid;
};

export const countries = [
  "United States",
  "United Kingdom",
  "Australia",
  "Canada",
  "France",
  "New Zealand",
  "India",
  "Brazil",
  "—",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Democratic Republic of the Congo",
  "Republic of the Congo",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "North Korea",
  "South Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];



// WEBPACK FOOTER //
// ./src/utils/forms.js